import Img from "components/atoms/Img";
import Title from "components/atoms/Title";
import IncludedFee from "components/molecules/IncludedFee";
import BankingPackages from "components/templates/vn/company-registration/BankingPackages";

const Component = ({ data, country, title }) => {
  return (
    <div id="banking_options">
      <div className="container">
        <div>
          <Title
            className="bbc-title mb-6 text-center capitalize"
            text={title ? title : `Open a Bank Account for ${country} Company `}
          />
          <p
            className="m-auto w-5/6 text-center"
            dangerouslySetInnerHTML={{
              __html:
                data.note ||
                "Note: Our banking support fee does not include the fee for bank account application or any other required fee (if any) chargeable by the bank you choose to apply.",
            }}
          />
        </div>
      </div>
      <div className="relative overflow-hidden pt-10">
        <div className="container relative z-20">
          <div className="row justify-center">
            {data.dataBankingPackage?.length > 0 && (
              <BankingPackages data={data.dataBankingPackage} />
            )}
          </div>
        </div>

        <Img
          src="/assets/images/wave/top_bg-wave.png"
          width={1920}
          height={125}
          className="w-full"
          wrapper={{
            className: "w-full absolute left-0 right-0 z-10 ",
            style: { top: "6rem" },
          }}
          alt="Wave top"
        />
        <div
          className=" absolute bottom-0 z-0 h-full w-full bg-bbc-package"
          style={{ top: "100px" }}
        ></div>
      </div>
      <div className="bg-bbc-package pt-10 lg:pt-20">
        <div className="container">
          <IncludedFee data={data.included} />
        </div>
      </div>
      <div className="relative">
        <div className=" absolute hidden h-1/2 w-full bg-bbc-package md:block"></div>
        <Img
          src="/assets/images/wave/bottom-wave.png"
          width={1920}
          height={140}
          className="w-full"
          wrapper={{ className: "absolute w-full top-1/2 hidden md:block" }}
          alt="Wave bottom"
        />
      </div>
    </div>
  );
};

export default Component;
